import React from 'react';

import PropTypes from 'prop-types';

import { Loader2 } from 'lucide-react';
import Spinner from '@/components/common/Spinner';
import classes from '@/orderForm/fields/FileUpload/style.module.scss';

const FileUploadComponent = ({ formData, id, name, options, file, remoteUri, isBusy, handleChange }) => (
  <div className="relative mb-3">
    {isBusy && (
      <div className="absolute inset-x-0 top-[2.5vw] bottom-0 bg-white/75 flex items-center justify-center z-10">
        <Loader2 className="animate-spin text-[#333]" size={20} />
      </div>
    )}
    
    <label 
      className="block text-[12px] font-normal text-[#1C3B5E] font-['Open_Sans'] mb-[0.5vw] tracking-tight" 
      htmlFor={id}
    >
      {name}
    </label>

    <div className="flex items-center gap-2">
      <input
        type="file"
        id={id}
        onChange={handleChange}
        accept={options.accept}
        data-cy={`${String(name).toLowerCase()}-file`}
        className="hidden"
      />
      <label 
        htmlFor={id} 
        className="inline-flex items-center justify-center w-[160px] h-[32px] bg-[#333] hover:bg-[#444] text-white text-[0.75rem] font-medium rounded-[3px] cursor-pointer transition-colors"
      >
        Selecionar imagem...
      </label>

      {file && (
        <div className="text-[12px] text-gray-500 italic">
          <span className="max-w-[140px] truncate inline-block align-middle">{file.name}</span>
          <span className="ml-1">
            ({(file.size / 1024).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            KB)
          </span>
        </div>
      )}
    </div>

    {(formData || remoteUri) && (
      <div className="mt-3 max-w-[180px] max-height-[180px] border rounded overflow-hidden shadow-sm">
        <img src={remoteUri || formData} alt="Imagem da fachada" className="w-full h-full object-cover" />
      </div>
    )}
  </div>
);

FileUploadComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isBusy: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  required: PropTypes.bool.isRequired,
  formData: PropTypes.string,
  file: PropTypes.instanceOf(File),
  remoteUri: PropTypes.string,
};

FileUploadComponent.defaultProps = {
  formData: null,
  file: null,
  remoteUri: null,
};

export default FileUploadComponent;
